webpackJsonp([9],{

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(815)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(818),
  /* template */
  __webpack_require__(828),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 815:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(816);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("0e8c143c", content, true);

/***/ }),

/***/ 816:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, "#app,body,html{height:100%;overflow:hidden}#share{position:relative;margin:0;padding-top:1px;font-family:\"sans-serif\",PingFang SC,Microsoft YaHei,\\\\5FAE\\8F6F\\96C5\\9ED1,Helvetica,STHeiti,WenQuanYi Micro Hei,SimSun;color:#333;background:url(" + __webpack_require__(817) + ") no-repeat;background-size:100% 100%;width:100%;height:100%;text-align:center}#share .text1{height:100px}p{margin:0}.cup{height:8.25rem;width:auto;margin:57px auto 0}.cup-child{position:absolute;top:0;left:0;width:100%}.part2{width:16.25rem;margin:0 auto;font-size:1.25rem;font-weight:800;line-height:1.56rem;color:#ffef39;margin-top:1.03rem}.show_prize{margin-top:1.03rem;color:#ffef39;font-size:1.06rem;line-height:2.06rem}.show_prize .number{font-size:2.25rem}.show_prize .number span{white-space:2px;font-family:boldNumber;letter-spacing:2px}.part3{margin-top:2.28rem;color:#fff;line-height:1.25rem;margin-bottom:.875rem;font-size:.875rem}.part3>*{display:inline-block;vertical-align:middle}.part3 img{height:1.25rem;width:auto;margin-left:.31rem}.part4{color:#fff;line-height:1.25rem;font-size:.875rem;padding:0 1.875rem}.code-box{margin-top:1.5rem;color:#fff;position:relative}.code-box>*{height:2.812rem;line-height:2.812rem;display:inline-block;font-size:0;margin:0}.code-box p{margin:auto;width:80%;padding:0;border:1px solid hsla(0,0%,98%,.5);border-radius:2.812rem;font-size:15px;z-index:100;background:rgba(0,0,0,.3);outline:none;font-weight:800;font-size:1.25rem;letter-spacing:2px;text-indent:1.5em;color:#fff;box-sizing:border-box;text-align:left}.code-box ::-webkit-input-placeholder{color:#999}.code-box :-moz-placeholder,.code-box ::-moz-placeholder{color:#999}.code-box .ok_btn{position:absolute;width:6.41rem;color:#fff;margin-left:-6.875rem;font-size:.937rem}.code-box .ok_btn .code-sure{height:1.25rem;width:auto;display:inline-block;vertical-align:text-bottom;padding-left:.625rem;margin-right:.31rem;border-left:1px solid hsla(0,0%,98%,.3)}.code-box .share-text{width:100%;text-align:center}.download{margin:auto;margin-top:1.875rem;color:#fff;background-color:#16ac3a;border-radius:1.56rem;width:14.973rem;height:3.125rem;line-height:3.125rem;font-size:1.25rem}.download img{height:1.187rem;width:auto;vertical-align:middle;margin-left:.31rem}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite/src/pages/AppAnswerShare.vue"],"names":[],"mappings":"AACA,eAGE,YAAa,AACb,eAAiB,CAClB,AACD,OACE,kBAAmB,AACnB,SAAU,AACV,gBAAiB,AACjB,wHAA2I,AAC3I,WAAY,AACZ,mDAAiE,AACjE,0BAA2B,AAC3B,WAAY,AACZ,YAAa,AACb,iBAAmB,CACpB,AACD,cACE,YAAc,CACf,AACD,EACE,QAAU,CACX,AACD,KACE,eAAgB,AAChB,WAAY,AACZ,kBAAoB,CACrB,AACD,WACE,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,UAAY,CACb,AACD,OACE,eAAgB,AAChB,cAAe,AACf,kBAAmB,AACnB,gBAAiB,AACjB,oBAAqB,AACrB,cAAe,AACf,kBAAoB,CACrB,AACD,YACE,mBAAoB,AACpB,cAAe,AACf,kBAAmB,AACnB,mBAAqB,CACtB,AACD,oBACE,iBAAmB,CACpB,AACD,yBACE,gBAAiB,AACjB,uBAA0B,AAC1B,kBAAoB,CACrB,AACD,OACE,mBAAoB,AACpB,WAAY,AACZ,oBAAqB,AACrB,sBAAwB,AACxB,iBAAoB,CACrB,AACD,SACE,qBAAsB,AACtB,qBAAuB,CACxB,AACD,WACE,eAAgB,AAChB,WAAY,AACZ,kBAAoB,CACrB,AACD,OACE,WAAY,AACZ,oBAAqB,AACrB,kBAAoB,AACpB,kBAAoB,CACrB,AACD,UACE,kBAAmB,AACnB,WAAY,AACZ,iBAAmB,CACpB,AACD,YACE,gBAAiB,AACjB,qBAAsB,AACtB,qBAAsB,AACtB,YAAa,AACb,QAAU,CACX,AACD,YACE,YAAa,AACb,UAAW,AACX,UAAW,AACX,mCAA2C,AAC3C,uBAAwB,AACxB,eAAgB,AAChB,YAAa,AACb,0BAA+B,AAC/B,aAAc,AACd,gBAAiB,AACjB,kBAAmB,AACnB,mBAAoB,AACpB,kBAAmB,AACnB,WAAY,AACZ,sBAAuB,AACvB,eAAiB,CAClB,AACD,sCAEE,UAAY,CACb,AAKD,yDAEE,UAAY,CACb,AACD,kBACE,kBAAmB,AACnB,cAAe,AACf,WAAY,AACZ,sBAAuB,AACvB,iBAAmB,CACpB,AACD,6BACE,eAAgB,AAChB,WAAY,AACZ,qBAAsB,AACtB,2BAA4B,AAC5B,qBAAsB,AACtB,oBAAqB,AACrB,uCAAgD,CACjD,AACD,sBACE,WAAY,AACZ,iBAAmB,CACpB,AACD,UACE,YAAa,AACb,oBAAqB,AACrB,WAAY,AACZ,yBAA0B,AAC1B,sBAAuB,AACvB,gBAAiB,AACjB,gBAAiB,AACjB,qBAAsB,AACtB,iBAAmB,CACpB,AACD,cACE,gBAAiB,AACjB,WAAY,AACZ,sBAAuB,AACvB,kBAAoB,CACrB","file":"AppAnswerShare.vue","sourcesContent":["\nbody,\nhtml,\n#app {\n  height: 100%;\n  overflow: hidden;\n}\n#share {\n  position: relative;\n  margin: 0;\n  padding-top: 1px;\n  font-family: 'sans-serif', 'PingFang SC', 'Microsoft YaHei', '微软雅黑', 'Helvetica', 'STHeiti', 'WenQuanYi Micro Hei', 'SimSun', 'sans-serif';\n  color: #333;\n  background: url(\"../assets/answer-share/share_bg.jpg\") no-repeat;\n  background-size: 100% 100%;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n}\n#share .text1 {\n  height: 100px;\n}\np {\n  margin: 0;\n}\n.cup {\n  height: 8.25rem;\n  width: auto;\n  margin: 57px auto 0;\n}\n.cup-child {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n}\n.part2 {\n  width: 16.25rem;\n  margin: 0 auto;\n  font-size: 1.25rem;\n  font-weight: 800;\n  line-height: 1.56rem;\n  color: #ffef39;\n  margin-top: 1.03rem;\n}\n.show_prize {\n  margin-top: 1.03rem;\n  color: #ffef39;\n  font-size: 1.06rem;\n  line-height: 2.06rem;\n}\n.show_prize .number {\n  font-size: 2.25rem;\n}\n.show_prize .number span {\n  white-space: 2px;\n  font-family: 'boldNumber';\n  letter-spacing: 2px;\n}\n.part3 {\n  margin-top: 2.28rem;\n  color: #fff;\n  line-height: 1.25rem;\n  margin-bottom: 0.875rem;\n  font-size: 0.875rem;\n}\n.part3 > * {\n  display: inline-block;\n  vertical-align: middle;\n}\n.part3 img {\n  height: 1.25rem;\n  width: auto;\n  margin-left: .31rem;\n}\n.part4 {\n  color: #fff;\n  line-height: 1.25rem;\n  font-size: 0.875rem;\n  padding: 0 1.875rem;\n}\n.code-box {\n  margin-top: 1.5rem;\n  color: #fff;\n  position: relative;\n}\n.code-box > * {\n  height: 2.812rem;\n  line-height: 2.812rem;\n  display: inline-block;\n  font-size: 0;\n  margin: 0;\n}\n.code-box p {\n  margin: auto;\n  width: 80%;\n  padding: 0;\n  border: 1px solid rgba(250, 250, 250, 0.5);\n  border-radius: 2.812rem;\n  font-size: 15px;\n  z-index: 100;\n  background: rgba(0, 0, 0, 0.3);\n  outline: none;\n  font-weight: 800;\n  font-size: 1.25rem;\n  letter-spacing: 2px;\n  text-indent: 1.5em;\n  color: #fff;\n  box-sizing: border-box;\n  text-align: left;\n}\n.code-box ::-webkit-input-placeholder {\n  /* WebKit browsers */\n  color: #999;\n}\n.code-box :-moz-placeholder {\n  /* Mozilla Firefox 4 to 18 */\n  color: #999;\n}\n.code-box ::-moz-placeholder {\n  /* Mozilla Firefox 19+ */\n  color: #999;\n}\n.code-box .ok_btn {\n  position: absolute;\n  width: 6.41rem;\n  color: #fff;\n  margin-left: -6.875rem;\n  font-size: .937rem;\n}\n.code-box .ok_btn .code-sure {\n  height: 1.25rem;\n  width: auto;\n  display: inline-block;\n  vertical-align: text-bottom;\n  padding-left: .625rem;\n  margin-right: .31rem;\n  border-left: 1px solid rgba(250, 250, 250, 0.3);\n}\n.code-box .share-text {\n  width: 100%;\n  text-align: center;\n}\n.download {\n  margin: auto;\n  margin-top: 1.875rem;\n  color: #fff;\n  background-color: #16ac3a;\n  border-radius: 1.56rem;\n  width: 14.973rem;\n  height: 3.125rem;\n  line-height: 3.125rem;\n  font-size: 1.25rem;\n}\n.download img {\n  height: 1.187rem;\n  width: auto;\n  vertical-align: middle;\n  margin-left: .31rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 817:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/share_bg.8cc9c4d.jpg";

/***/ }),

/***/ 818:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clipboard2__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_clipboard2__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_clipboard2___default.a);
/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            tmp_data: {
                code: this.$route.query.code,
                prize: this.$route.query.prize
            }
        };
    },
    mounted: function mounted() {
        document.title = 'Super Football Hero';
    },

    methods: {
        copySuccess: function copySuccess() {
            this.$toast(this.$t('copied'));
        },
        copyError: function copyError() {
            this.$toast(this.$t('copyFailed'));
        },
        download: function download() {
            location.href = 'https://go.onelink.me/1751978436?pid=PM2.2';
        }
    }
});

/***/ }),

/***/ 819:
/***/ (function(module, exports, __webpack_require__) {

var Clipboard = __webpack_require__(820)

var VueClipboard = {
  install: function (Vue) {
    Vue.prototype.$copyText = function (text) {
      return new Promise(function (resolve, reject) {
        var fake_el = document.createElement('button');
        var clipboard = new Clipboard(fake_el, {
          text: function () { return text },
          action: function () { return 'copy' }
        });
        clipboard.on('success', function (e) {
          clipboard.destroy();
          resolve(e);
        });
        clipboard.on('error', function (e) {
          clipboard.destroy();
          reject(e);
        });
        fake_el.click();
      });
    };

    Vue.directive('clipboard', {
      bind: function (el, binding, vnode) {
        if(binding.arg === 'success') {
          el._v_clipboard_success = binding.value
        } else if(binding.arg === 'error') {
          el._v_clipboard_error = binding.value
        } else {
          var clipboard = new Clipboard(el, {
            text: function () { return binding.value },
            action: function () { return binding.arg === 'cut' ? 'cut' : 'copy' }
          })
          clipboard.on('success', function (e) {
            var callback = el._v_clipboard_success
            callback && callback(e)
          })
          clipboard.on('error', function (e) {
            var callback = el._v_clipboard_error
            callback && callback(e)
          })
          el._v_clipboard = clipboard
        }
      },
      update: function (el, binding) {
        if(binding.arg === 'success') {
          el._v_clipboard_success = binding.value
        } else if(binding.arg === 'error') {
          el._v_clipboard_error = binding.value
        } else {
          el._v_clipboard.text = function () { return binding.value }
          el._v_clipboard.action = function () { return binding.arg === 'cut' ? 'cut' : 'copy' }
        }
      },
      unbind: function (el, binding) {
        if(binding.arg === 'success') {
          delete el._v_clipboard_success
        } else if(binding.arg === 'error') {
          delete el._v_clipboard_error
        } else {
          el._v_clipboard.destroy()
          delete el._v_clipboard
        }
      }
    })
  }
}

if (true) {
  module.exports = VueClipboard
} else if (typeof define == "function" && define.amd) {
  define([], function() {
    return VueClipboard
  })
}


/***/ }),

/***/ 820:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(821), __webpack_require__(823), __webpack_require__(824)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('./clipboard-action'), require('tiny-emitter'), require('good-listener'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.clipboardAction, global.tinyEmitter, global.goodListener);
        global.clipboard = mod.exports;
    }
})(this, function (module, _clipboardAction, _tinyEmitter, _goodListener) {
    'use strict';

    var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

    var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

    var _goodListener2 = _interopRequireDefault(_goodListener);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var Clipboard = function (_Emitter) {
        _inherits(Clipboard, _Emitter);

        /**
         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
         * @param {Object} options
         */
        function Clipboard(trigger, options) {
            _classCallCheck(this, Clipboard);

            var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));

            _this.resolveOptions(options);
            _this.listenClick(trigger);
            return _this;
        }

        /**
         * Defines if attributes would be resolved using internal setter functions
         * or custom functions that were passed in the constructor.
         * @param {Object} options
         */


        _createClass(Clipboard, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
                this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
                this.text = typeof options.text === 'function' ? options.text : this.defaultText;
                this.container = _typeof(options.container) === 'object' ? options.container : document.body;
            }
        }, {
            key: 'listenClick',
            value: function listenClick(trigger) {
                var _this2 = this;

                this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
                    return _this2.onClick(e);
                });
            }
        }, {
            key: 'onClick',
            value: function onClick(e) {
                var trigger = e.delegateTarget || e.currentTarget;

                if (this.clipboardAction) {
                    this.clipboardAction = null;
                }

                this.clipboardAction = new _clipboardAction2.default({
                    action: this.action(trigger),
                    target: this.target(trigger),
                    text: this.text(trigger),
                    container: this.container,
                    trigger: trigger,
                    emitter: this
                });
            }
        }, {
            key: 'defaultAction',
            value: function defaultAction(trigger) {
                return getAttributeValue('action', trigger);
            }
        }, {
            key: 'defaultTarget',
            value: function defaultTarget(trigger) {
                var selector = getAttributeValue('target', trigger);

                if (selector) {
                    return document.querySelector(selector);
                }
            }
        }, {
            key: 'defaultText',
            value: function defaultText(trigger) {
                return getAttributeValue('text', trigger);
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.listener.destroy();

                if (this.clipboardAction) {
                    this.clipboardAction.destroy();
                    this.clipboardAction = null;
                }
            }
        }], [{
            key: 'isSupported',
            value: function isSupported() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];

                var actions = typeof action === 'string' ? [action] : action;
                var support = !!document.queryCommandSupported;

                actions.forEach(function (action) {
                    support = support && !!document.queryCommandSupported(action);
                });

                return support;
            }
        }]);

        return Clipboard;
    }(_tinyEmitter2.default);

    /**
     * Helper function to retrieve attribute value.
     * @param {String} suffix
     * @param {Element} element
     */
    function getAttributeValue(suffix, element) {
        var attribute = 'data-clipboard-' + suffix;

        if (!element.hasAttribute(attribute)) {
            return;
        }

        return element.getAttribute(attribute);
    }

    module.exports = Clipboard;
});

/***/ }),

/***/ 821:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(822)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('select'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.select);
        global.clipboardAction = mod.exports;
    }
})(this, function (module, _select) {
    'use strict';

    var _select2 = _interopRequireDefault(_select);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    var ClipboardAction = function () {
        /**
         * @param {Object} options
         */
        function ClipboardAction(options) {
            _classCallCheck(this, ClipboardAction);

            this.resolveOptions(options);
            this.initSelection();
        }

        /**
         * Defines base properties passed from constructor.
         * @param {Object} options
         */


        _createClass(ClipboardAction, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = options.action;
                this.container = options.container;
                this.emitter = options.emitter;
                this.target = options.target;
                this.text = options.text;
                this.trigger = options.trigger;

                this.selectedText = '';
            }
        }, {
            key: 'initSelection',
            value: function initSelection() {
                if (this.text) {
                    this.selectFake();
                } else if (this.target) {
                    this.selectTarget();
                }
            }
        }, {
            key: 'selectFake',
            value: function selectFake() {
                var _this = this;

                var isRTL = document.documentElement.getAttribute('dir') == 'rtl';

                this.removeFake();

                this.fakeHandlerCallback = function () {
                    return _this.removeFake();
                };
                this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;

                this.fakeElem = document.createElement('textarea');
                // Prevent zooming on iOS
                this.fakeElem.style.fontSize = '12pt';
                // Reset box model
                this.fakeElem.style.border = '0';
                this.fakeElem.style.padding = '0';
                this.fakeElem.style.margin = '0';
                // Move element out of screen horizontally
                this.fakeElem.style.position = 'absolute';
                this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
                // Move element to the same position vertically
                var yPosition = window.pageYOffset || document.documentElement.scrollTop;
                this.fakeElem.style.top = yPosition + 'px';

                this.fakeElem.setAttribute('readonly', '');
                this.fakeElem.value = this.text;

                this.container.appendChild(this.fakeElem);

                this.selectedText = (0, _select2.default)(this.fakeElem);
                this.copyText();
            }
        }, {
            key: 'removeFake',
            value: function removeFake() {
                if (this.fakeHandler) {
                    this.container.removeEventListener('click', this.fakeHandlerCallback);
                    this.fakeHandler = null;
                    this.fakeHandlerCallback = null;
                }

                if (this.fakeElem) {
                    this.container.removeChild(this.fakeElem);
                    this.fakeElem = null;
                }
            }
        }, {
            key: 'selectTarget',
            value: function selectTarget() {
                this.selectedText = (0, _select2.default)(this.target);
                this.copyText();
            }
        }, {
            key: 'copyText',
            value: function copyText() {
                var succeeded = void 0;

                try {
                    succeeded = document.execCommand(this.action);
                } catch (err) {
                    succeeded = false;
                }

                this.handleResult(succeeded);
            }
        }, {
            key: 'handleResult',
            value: function handleResult(succeeded) {
                this.emitter.emit(succeeded ? 'success' : 'error', {
                    action: this.action,
                    text: this.selectedText,
                    trigger: this.trigger,
                    clearSelection: this.clearSelection.bind(this)
                });
            }
        }, {
            key: 'clearSelection',
            value: function clearSelection() {
                if (this.trigger) {
                    this.trigger.focus();
                }

                window.getSelection().removeAllRanges();
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.removeFake();
            }
        }, {
            key: 'action',
            set: function set() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';

                this._action = action;

                if (this._action !== 'copy' && this._action !== 'cut') {
                    throw new Error('Invalid "action" value, use either "copy" or "cut"');
                }
            },
            get: function get() {
                return this._action;
            }
        }, {
            key: 'target',
            set: function set(target) {
                if (target !== undefined) {
                    if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
                        if (this.action === 'copy' && target.hasAttribute('disabled')) {
                            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                        }

                        if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                        }

                        this._target = target;
                    } else {
                        throw new Error('Invalid "target" value, use a valid Element');
                    }
                }
            },
            get: function get() {
                return this._target;
            }
        }]);

        return ClipboardAction;
    }();

    module.exports = ClipboardAction;
});

/***/ }),

/***/ 822:
/***/ (function(module, exports) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;


/***/ }),

/***/ 823:
/***/ (function(module, exports) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;


/***/ }),

/***/ 824:
/***/ (function(module, exports, __webpack_require__) {

var is = __webpack_require__(825);
var delegate = __webpack_require__(826);

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;


/***/ }),

/***/ 825:
/***/ (function(module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};


/***/ }),

/***/ 826:
/***/ (function(module, exports, __webpack_require__) {

var closest = __webpack_require__(827);

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function _delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === 'function') {
        return _delegate.apply(null, arguments);
    }

    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === 'function') {
        // Use `document` as the first parameter, then apply arguments
        // This is a short way to .unshift `arguments` without running into deoptimizations
        return _delegate.bind(null, document).apply(null, arguments);
    }

    // Handle Selector-based usage
    if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function (element) {
        return _delegate(element, selector, type, callback, useCapture);
    });
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;


/***/ }),

/***/ 827:
/***/ (function(module, exports) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (typeof element.matches === 'function' &&
            element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
    }
}

module.exports = closest;


/***/ }),

/***/ 828:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "share"
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [
    [_c('img', {
      key: 'dom1',
      staticClass: "cup",
      attrs: {
        "src": __webpack_require__(829),
        "alt": ""
      }
    }), _vm._v(" "), _c('img', {
      key: 'dom11',
      staticClass: "cup-child",
      attrs: {
        "src": __webpack_require__(830),
        "alt": ""
      }
    }), _vm._v(" "), (!_vm.tmp_data.prize) ? _c('p', {
      key: 'dom2',
      staticClass: "part2"
    }, [_vm._v(_vm._s(_vm.$t('shareComm')))]) : _c('div', {
      key: 'dom41',
      staticClass: "show_prize"
    }, [_c('p', {
      staticClass: "text"
    }, [_vm._v(_vm._s(_vm.$t('shareBouns')))]), _vm._v(" "), _c('p', {
      staticClass: "number"
    }, [_vm._v("$"), _c('span', [_vm._v(_vm._s(_vm.tmp_data.prize))])])]), _vm._v(" "), _c('div', {
      key: 'dom3',
      staticClass: "part3"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('download')))]), _c('img', {
      attrs: {
        "src": __webpack_require__(831),
        "alt": ""
      }
    })]), _vm._v(" "), _c('p', {
      key: 'dom4',
      staticClass: "part4"
    }, [_vm._v(_vm._s(_vm.$t('share')))]), _vm._v(" "), _c('div', {
      key: 'dom5',
      staticClass: "code-box"
    }, [_c('p', [_vm._v(_vm._s(_vm.tmp_data.code))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (_vm.tmp_data.code),
        expression: "tmp_data.code",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.copySuccess),
        expression: "copySuccess",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.copyError),
        expression: "copyError",
        arg: "error"
      }],
      staticClass: "ok_btn"
    }, [_c('img', {
      staticClass: "code-sure",
      attrs: {
        "src": __webpack_require__(832),
        "alt": ""
      }
    }), _vm._v(_vm._s(_vm.$t('copy')) + "\n                ")])]), _vm._v(" "), _c('div', {
      key: 'dom6',
      staticClass: "download",
      on: {
        "click": _vm.download
      }
    }, [_vm._v(_vm._s(_vm.$t('download'))), _c('img', {
      attrs: {
        "src": __webpack_require__(833),
        "alt": ""
      }
    })])]
  ], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 829:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cup.8f14b8b.png";

/***/ }),

/***/ 830:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cup-child.1f048c6.png";

/***/ }),

/***/ 831:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/AFlogo.4498761.png";

/***/ }),

/***/ 832:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAMAAAANmfvwAAAAeFBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////GqOSsAAAAJ3RSTlMA0DCwoCD79eyrIwKWjmENCPbx1rx6dldLEuXgwLqegmlmRDkrKR2EDf1+AAAAtUlEQVQ4y+3TyQqDMBRG4Ru1zlNHtfN83v8N6y5pDBZplz2LwA/fIgQiU6pPW+yiJDVEdsBVbJgGWCqrBSSaBFCK3TNirpcPMxmk4Hcka/Jgk42Rek9fO0YK+qJ0jMSEpdfJGAHVn3/yFXkMydIkBfg3z2oDO03uIc7WmkjpNElmEEnXx8CquIpoYuVdKj2cpIrIP5AZ+HqFxNWAtG/fcAWxsgvhbFxsjitVi2FWwxdZ5J1M6AU/7yxDuGP8JwAAAABJRU5ErkJggg=="

/***/ }),

/***/ 833:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAh1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9qkf8RAAAALHRSTlMAWoft5fkdBhQC1Ar8sZk4l3veuYgS8NbMxLauq5w7DlwrGdCMeEohvqB/NX6UU48AAAFASURBVDjLjZXpdoIwEIUvJkBABKFsCsW1dsv7P1/FCoFpOJ37D/KdmcwazBR0aVOJKBJhkyYBluTlUk8kc8+KqdjVRG6s/nKO0BYJh2D+q17Q1p9y6xe9qP16Ym/GUW2MTeKXKh64IzXxGemZnhEpQThgRWIvHmBMDK4Ah4b+qIf7P+j2NbpqO0j/BZIDygCd5oA6QcoD37DhgS1CHhii5IEC0ZirY1fPQXm7yfHUgC1w2E3B7B34GkHjOiuA9YcBKw/wd8a1Ceai7uR+AMNz/2WCmaanup/5m1+wVvO+b2cJz3pvbQ/WxXDjIeGmhMP9gwQ4HQinE9IU8oSnipo0BXJtI9WFFoE2rvjuuXNFGtcyCmUCeBkZBetwldurpMNFxnVJDncBsFcKd0lx1x5zkfJW81bxl71dQZI2of35+AGfGrfJMGLGNAAAAABJRU5ErkJggg=="

/***/ })

});


// WEBPACK FOOTER //
// static/js/9.c8216c345de193c19b4a.js